<template>
  <div class="header-right-presentation">
    <ControlActionHistories v-if="showControlActionHistories" :is-mobile="true"></ControlActionHistories>
    <div>
      <SyncLoading />
    </div>
    <div class="-mt-1">
      <aha-button @click="turnOffTabContent">
        Done
      </aha-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SyncLoading from '@/components-v2/presentation-editor/editor-header/SyncLoading'
import ControlActionHistories from '@/components-v2/presentation-editor/editor-header/ControlActionHistories'

export default {
  components: {
    ControlActionHistories,
    SyncLoading,
  },
  computed: {
    ...mapState({ slideActive: (state) => state.slideActive }),
    showControlActionHistories() {
      return this.slideActive.activeTab === 2
    },
  },
  methods: {
    turnOffTabContent() {
      this.$store.state.activeModelDetailSlide = false
    },
  },
}
</script>

<style lang="scss" scoped>
.header-right-presentation {
  @apply relative flex h-full shadow-top bg-base-0;
  @apply items-center justify-end w-full pl-3.5 pr-4;
  @apply z-10 h-14 md:h-15 md:hidden;

  .container-action-history{
    display: flex;
  }

  & ::v-deep {
    .header-present-btn {
      display: none;
    }
  }
}
</style>
